import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{
            padding: '20px',
            margin: '20px',
            background: '#fee',
            border: '2px solid #f00',
            borderRadius: '8px',
            fontFamily: 'system-ui'
          }}>
            <h2>Application Error</h2>
            <p><strong>Error:</strong> {this.state.error?.message}</p>
            <details>
              <summary>Stack trace</summary>
              <pre style={{ fontSize: '12px', overflow: 'auto' }}>{this.state.error?.stack}</pre>
            </details>
            <button 
              onClick={() => window.location.reload()}
              style={{
                marginTop: '10px',
                padding: '10px 20px',
                background: '#f00',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Reload Page
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;